import { useState } from "react";
import { Button } from "primereact/button";
import { Sidebar } from "primereact/sidebar";
import LayerSwitcher from "./LayerSwitcher";
import { map, explorer } from "../../_config/map";
import "./LayerSwitcher.css";
import { useTranslation } from "react-i18next";
import { Tooltip } from "primereact/tooltip";

function ButtonSwitcher(props) {
  const [visible, setVisible] = useState(false);
  const collapseSwitcher = true;
  const { t } = useTranslation();

  return (
    <>
      <Tooltip
        target=".ButtonSideBar"
        content={t("btn.sidebar")}
        position="bottom"
        className="CustomTooltip"
      />

      <Button
        icon="pi pi-list"
        onClick={() => setVisible(true)}
        className="ButtonSideBar"
        severity="info"
      />

   
        <Sidebar
          visible={visible}
          onHide={() => setVisible(false)}
          position="right"
          style={{ width: "470px" }}
          className="TogglerSwitcher"
          header="Explorador de dados"
        >
          <LayerSwitcher
            map={map}
            explorer={explorer}
            currentLanguage="pt"
            visible={visible}
            hasNewVisibleLayer={props.hasNewVisibleLayer}
            collapsed={collapseSwitcher}
          />
        </Sidebar>
     
    </>
  );
}

export default ButtonSwitcher;
